module.exports = __webpack_public_path__ + "media/images/real-royal-868b019729a9187d703ac5637971cfa4.png";